// ============================================
// POWER FRAGRANCES — Theme JS
// ============================================

/* ---------- CART DRAWER ---------- */
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
}

/* ---------- MOBILE NAV ---------- */
function toggleMenu() {
  const nav = document.getElementById('mobile-nav');
  nav.classList.toggle('open');
  document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
}

/* ---------- SEARCH PANEL ---------- */
let searchTimer = null;

function openSearch() {
  const panel = document.getElementById('search-panel');
  if (!panel) return;
  panel.classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(() => {
    const input = document.getElementById('search-input');
    if (input) input.focus();
  }, 120);
}

function closeSearch() {
  const panel = document.getElementById('search-panel');
  if (!panel) return;
  panel.classList.remove('open');
  document.body.style.overflow = '';
  clearSearch();
}

function clearSearch() {
  const input = document.getElementById('search-input');
  const clearBtn = document.getElementById('search-clear');
  if (input) input.value = '';
  if (clearBtn) clearBtn.style.display = 'none';
  resetSearchResults();
}

function resetSearchResults() {
  const results = document.getElementById('search-results');
  if (!results) return;
  results.innerHTML = `
    <div class="search-results__suggestions">
      <p class="search-results__hint">Popular searches</p>
      <div class="search-suggestions">
        <a href="/collections/best-sellers" class="search-suggestion">Best Sellers</a>
        <a href="/collections/women" class="search-suggestion">Women's</a>
        <a href="/collections/men" class="search-suggestion">Men's</a>
        <a href="/collections/unisex" class="search-suggestion">Unisex</a>
        <a href="/collections/bundles" class="search-suggestion">Bundles</a>
      </div>
    </div>`;
}

document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('search-input');
  const clearBtn = document.getElementById('search-clear');
  if (!input) return;

  input.addEventListener('input', function () {
    const q = this.value.trim();
    if (clearBtn) clearBtn.style.display = q.length > 0 ? 'inline-block' : 'none';
    clearTimeout(searchTimer);
    if (q.length < 2) { resetSearchResults(); return; }
    searchTimer = setTimeout(() => runSearch(q), 280);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      const q = this.value.trim();
      if (q.length > 0) window.location.href = '/search?q=' + encodeURIComponent(q);
    }
    if (e.key === 'Escape') closeSearch();
  });
});

function runSearch(query) {
  const results = document.getElementById('search-results');
  if (!results) return;

  results.innerHTML = '<div class="search-loading"><div class="search-spinner"></div>Searching…</div>';

  fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
    .then(r => r.json())
    .then(data => {
      const products = data.resources && data.resources.results && data.resources.results.products
        ? data.resources.results.products
        : [];

      if (products.length === 0) {
        results.innerHTML = `
          <p class="search-no-results">No results for "${escapeHtml(query)}" — try a different search.</p>
          <a href="/collections/all" class="search-view-all">Browse all fragrances</a>`;
        return;
      }

      let html = '<p class="search-results__heading">Products</p><div class="search-products">';
      products.forEach(p => {
        const name = (p.title || '').split(' —')[0];
        const inspired = p.title && p.title.includes('—') ? p.title.split('— ')[1] || '' : '';
        const img = p.image ? p.image : '';
        const price = p.price ? '£' + (parseFloat(p.price)).toFixed(2) : '';
        html += `<a href="${p.url}" class="search-product" onclick="closeSearch()">
          ${img ? `<img src="${img}" alt="${escapeHtml(name)}" class="search-product__img">` : '<div class="search-product__img"></div>'}
          <div class="search-product__info">
            <div class="search-product__name">${escapeHtml(name)}</div>
            ${inspired ? `<div class="search-product__inspired">${escapeHtml(inspired)}</div>` : ''}
            ${price ? `<div class="search-product__price">from ${price}</div>` : ''}
          </div>
        </a>`;
      });
      html += '</div>';
      html += `<a href="/search?q=${encodeURIComponent(query)}" class="search-view-all">See all results for "${escapeHtml(query)}" →</a>`;
      results.innerHTML = html;
    })
    .catch(() => {
      results.innerHTML = '<p class="search-no-results">Something went wrong. Please try again.</p>';
    });
}

function escapeHtml(str) {
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* ---------- QUICK ADD / ADD TO CART (AJAX) ---------- */
document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form.classList.contains('atc-form') && !form.classList.contains('product-form')) return;
  e.preventDefault();
  const btn = form.querySelector('button[type="submit"]');
  const orig = btn.textContent;
  btn.textContent = 'Adding…';
  btn.disabled = true;
  const idInput = form.querySelector('[name="id"]');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: idInput.value, quantity: 1 })
  })
    .then(r => r.json())
    .then(() => fetch('/cart.js'))
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('.cart-badge').forEach(b => {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      btn.textContent = '✓ Added';
      btn.disabled = false;
      if (form.classList.contains('atc-form')) { openCart(); refreshCartDrawer(); }
      setTimeout(() => { btn.textContent = orig; }, 1800);
    })
    .catch(() => { btn.textContent = orig; btn.disabled = false; });
});

function refreshCartDrawer() {
  fetch('/cart.js').then(r => r.json()).then(cart => {
    const body = document.getElementById('cart-drawer-body');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty-state"><p>Your bag is empty</p><a href="/collections/all" class="btn btn--gold" onclick="closeCart()">Explore Fragrances</a></div>';
      return;
    }
    let html = '';
    cart.items.forEach((item, i) => {
      const name = item.product_title.split(' —')[0];
      html += `<div class="cart-item"><img src="${item.image}" alt="${item.title}"><div class="cart-item__info"><div class="cart-item__name">${name}</div><div class="cart-item__variant">${item.variant_title || ''}</div><div class="cart-item__price">${formatMoney(item.price)}</div></div><a href="/cart/change?line=${i+1}&quantity=0" class="cart-item__remove" onclick="event.preventDefault();removeCartLine(${i+1})">&#x2715;</a></div>`;
    });
    const deliveryHtml = document.querySelector('.delivery-countdown')?.outerHTML || '';
    html += `<div class="cart-drawer__delivery">${deliveryHtml}</div>`;
    html += `<div class="cart-drawer__footer"><div class="cart-total"><span>Subtotal</span><span>${formatMoney(cart.total_price)}</span></div><a href="/checkout" class="btn btn--gold btn--full">Checkout Securely</a><a href="/cart" class="btn btn--outline btn--full" onclick="closeCart()">View Bag</a></div>`;
    body.innerHTML = html;
  });
}

function removeCartLine(line) {
  fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({line,quantity:0}) })
    .then(r=>r.json()).then(cart => {
      document.querySelectorAll('.cart-badge').forEach(b => { b.textContent=cart.item_count; b.style.display=cart.item_count>0?'flex':'none'; });
      refreshCartDrawer();
    });
}

function formatMoney(cents) { return '£'+(cents/100).toFixed(2); }

/* ---------- BUY NOW ---------- */
function buyNow(btn) {
  const form = btn.closest('form');
  const idInput = form.querySelector('[name="id"]');
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:idInput.value,quantity:1})})
    .then(()=>{window.location.href='/checkout';});
}

/* ---------- PRODUCT PAGE ---------- */
function updateVariant(input, price) {
  document.querySelectorAll('.size-option').forEach(o=>o.classList.remove('active'));
  input.closest('.size-option').classList.add('active');
  const priceEl = document.getElementById('product-price');
  if (priceEl) priceEl.textContent = price;
  const stickyPrice = document.getElementById('sticky-price');
  if (stickyPrice) stickyPrice.textContent = price;
}

function swapImage(src, thumbEl) {
  const img = document.getElementById('main-img');
  if (img) img.src = src;
  document.querySelectorAll('.product-thumb').forEach(t=>t.classList.remove('active'));
  if (thumbEl) thumbEl.classList.add('active');
}

(function(){
  const container = document.querySelector('[data-zoom]');
  if (!container) return;
  const img = container.querySelector('[data-zoom-img]');
  if (!img) return;
  container.addEventListener('mousemove', function(e){
    if (window.innerWidth < 960) return;
    const rect = container.getBoundingClientRect();
    img.style.transformOrigin = `${((e.clientX-rect.left)/rect.width)*100}% ${((e.clientY-rect.top)/rect.height)*100}%`;
    img.style.transform = 'scale(1.8)';
  });
  container.addEventListener('mouseleave', function(){ img.style.transform='scale(1)'; });
})();

(function(){
  const sticky = document.getElementById('sticky-atc');
  const form = document.querySelector('.product-form');
  if (!sticky||!form) return;
  function onScroll(){
    if (window.innerWidth>=960){sticky.style.display='none';return;}
    sticky.style.display = form.getBoundingClientRect().top < -100 ? 'flex':'none';
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  onScroll();
})();

/* ---------- STATS COUNTER ---------- */
(function(){
  const section = document.querySelector('[data-stats-section]');
  if (!section) return;
  let animated = false;
  function animateCounters(){
    if (animated) return;
    const rect = section.getBoundingClientRect();
    if (rect.top > window.innerHeight || rect.bottom < 0) return;
    animated = true;
    document.querySelectorAll('[data-count-to]').forEach(el=>{
      const target = parseInt(el.getAttribute('data-count-to'),10)||0;
      const suffix = el.getAttribute('data-suffix')||'';
      const start = performance.now();
      function step(now){
        const p = Math.min((now-start)/1800,1);
        const e2 = 1-Math.pow(1-p,3);
        el.textContent = Math.floor(e2*target).toLocaleString('en-GB')+suffix;
        if (p<1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString('en-GB')+suffix;
      }
      requestAnimationFrame(step);
    });
  }
  window.addEventListener('scroll',animateCounters,{passive:true});
  window.addEventListener('load',animateCounters);
  animateCounters();
})();

/* ---------- CAROUSEL ---------- */
function carouselScroll(trackId, direction){
  const track = document.getElementById(trackId);
  if (!track) return;
  const card = track.querySelector('.product-card');
  track.scrollBy({left: direction*(card?card.offsetWidth:280)*2, behavior:'smooth'});
}

/* ---------- WISHLIST ---------- */
function getWishlist(){try{return JSON.parse(localStorage.getItem('pf_wishlist')||'[]');}catch(e){return[];}}
function saveWishlist(list){localStorage.setItem('pf_wishlist',JSON.stringify(list));updateWishlistBadge();}
function updateWishlistBadge(){
  const list=getWishlist();
  const badge=document.getElementById('wishlist-badge');
  if(badge){badge.textContent=list.length;badge.style.display=list.length>0?'flex':'none';}
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn=>{
    const id=btn.getAttribute('data-wishlist-btn');
    btn.classList.toggle('active',!!list.find(p=>p.id===id));
  });
}
function toggleWishlist(e,id,title,image,url,price){
  e.preventDefault();e.stopPropagation();
  let list=getWishlist();
  list=list.find(p=>p.id===id)?list.filter(p=>p.id!==id):[...list,{id,title,image,url,price}];
  saveWishlist(list);
}
function toggleWishlistPanel(){
  const list=getWishlist();
  if(!list.length){alert('Your wishlist is empty. Tap the heart icon on any fragrance to save it here.');return;}
  alert('Your Wishlist:\n\n'+list.map(p=>`• ${p.title.replace(' —','')} — ${p.price}`).join('\n'));
}
document.addEventListener('DOMContentLoaded',updateWishlistBadge);

/* ---------- RECENTLY VIEWED ---------- */
document.addEventListener('DOMContentLoaded',function(){
  try{
    const data=JSON.parse(localStorage.getItem('pf_recently_viewed')||'[]');
    const grid=document.getElementById('recently-viewed-grid');
    const section=document.getElementById('recently-viewed-section');
    if(!grid||!section) return;
    const items=data.filter(p=>p.url!==window.location.pathname).slice(0,4);
    if(!items.length) return;
    items.forEach(p=>{
      const card=document.createElement('article');
      card.className='product-card';
      card.innerHTML=`<a href="${p.url}" class="product-card__media"><img src="${p.image}" alt="${p.title}" loading="lazy"></a><div class="product-card__info"><h3 class="product-card__name"><a href="${p.url}">${p.title}</a></h3><p class="product-card__inspired">${p.inspired||''}</p><div class="product-card__footer"><span class="product-card__price">from ${p.price}</span></div></div>`;
      grid.appendChild(card);
    });
    section.style.display='block';
  }catch(e){}
});

/* ---------- DELIVERY COUNTDOWN ---------- */
(function(){
  function updateCountdowns(){
    const els=document.querySelectorAll('[data-delivery-countdown]');
    if(!els.length) return;
    const now=new Date();
    const day=now.getDay();
    let message;
    if(day>=1&&day<=5&&now.getHours()<14){
      const cutoff=new Date(now);
      cutoff.setHours(14,0,0,0);
      const diff=cutoff-now;
      const h=Math.floor(diff/3600000);
      const m=Math.floor((diff%3600000)/60000);
      message=`Order within <strong>${h>0?h+(h===1?' hour ':' hours '):' '}${m} ${m===1?'minute':'minutes'}</strong> for next working day dispatch`;
    } else {
      message='Order now and your order will be dispatched next working day';
    }
    els.forEach(el=>{
      const t=el.querySelector('[data-countdown-text]');
      if(t) t.innerHTML=message+' · Royal Mail Tracked 24';
    });
  }
  updateCountdowns();
  setInterval(updateCountdowns,60000);
})();

/* ---------- FRAGRANCE QUIZ ---------- */
const quizState={gender:null,family:null,occasion:null};
function openQuiz(){document.getElementById('quiz-modal').classList.add('open');document.body.style.overflow='hidden';}
function closeQuiz(){document.getElementById('quiz-modal').classList.remove('open');document.body.style.overflow='';}
function quizNext(step){document.querySelectorAll('.quiz-step').forEach(s=>s.classList.remove('active'));const t=document.querySelector(`.quiz-step[data-step="${step}"]`);if(t)t.classList.add('active');}
function quizAnswer(key,value,next){quizState[key]=value;if(next===4)renderQuizResults();quizNext(next);}
function quizRestart(){quizState.gender=null;quizState.family=null;quizState.occasion=null;quizNext(0);}
function renderQuizResults(){
  const grid=document.getElementById('quiz-results');
  const summary=document.getElementById('quiz-result-summary');
  if(!grid) return;
  summary.textContent=`Based on your love of ${(quizState.family||'great').toLowerCase()} scents, here are our top picks:`;
  const cards=Array.from(document.querySelectorAll('[data-product-card]'));
  let matches=cards.filter(c=>!quizState.gender||quizState.gender==='Unisex'||c.textContent.toLowerCase().includes(quizState.gender.toLowerCase()));
  if(!matches.length) matches=cards;
  matches=matches.slice(0,3);
  if(!matches.length){grid.innerHTML='<p style="color:var(--grey);font-size:13px;padding:20px 0">Browse our full collection to find your perfect match.</p>';return;}
  grid.innerHTML=matches.map(card=>{
    const img=card.querySelector('img');
    const nameEl=card.querySelector('.product-card__name a');
    const inspiredEl=card.querySelector('.product-card__inspired');
    const priceEl=card.querySelector('.product-card__price');
    if(!nameEl) return '';
    return `<div class="quiz-result-item"><img src="${img?img.src:''}" alt=""><div class="quiz-result-item__info"><div class="quiz-result-item__name">${nameEl.textContent}</div><div class="quiz-result-item__inspired">${inspiredEl?inspiredEl.textContent:''}</div><div class="quiz-result-item__price">${priceEl?priceEl.textContent:''}</div></div><a href="${nameEl.getAttribute('href')}" class="btn btn--dark btn--sm" onclick="closeQuiz()">View</a></div>`;
  }).join('');
}

/* ---------- STICKY HEADER SHADOW ---------- */
window.addEventListener('scroll',()=>{
  const h=document.getElementById('site-header');
  if(h) h.style.boxShadow=window.scrollY>20?'0 2px 16px rgba(0,0,0,.05)':'none';
},{passive:true});
